import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Preloader from "@/components/Preloader";
import Butterfly from "@/components/Butterfly";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Showcase from "@/components/Showcase";
import BeforeAfter from "@/components/BeforeAfter";
import Checkered from "@/components/Checkered";
import ColorStory from "@/components/ColorStory";
import Gallery from "@/components/Gallery";
import VGraphics from "@/components/VGraphics";
import StageWraps from "@/components/StageWraps";
import PromoFilm from "@/components/PromoFilm";
import Testimonial from "@/components/Testimonial";
import Contact from "@/components/Contact";
import InstagramStrip from "@/components/InstagramStrip";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";

function Landing() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-ivory">
      <div className="grain-overlay" aria-hidden="true" />
      <AnimatePresence>
        {loading && <Preloader key="preloader" onDone={() => setLoading(false)} />}
      </AnimatePresence>
      <Butterfly />
      <Nav />
      <main>
        <Hero start={!loading} />
        <Marquee />
        <Showcase />
        <Manifesto />
        <BeforeAfter />
        <StageWraps />
        <Checkered />
        <ColorStory />
        <Gallery />
        <VGraphics />
        <PromoFilm />
        <Testimonial />
        <Contact />
      </main>
      <InstagramStrip />
      <Footer />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

function QuoteMe() {
  useEffect(() => {
    window.location.replace("https://cevemp.involve.me/fantasydancefloors");
  }, []);
  return (
    <div data-testid="quoteme-redirect" className="min-h-screen bg-ivory flex items-center justify-center px-6">
      <p className="font-serif italic text-2xl text-ink text-center">Taking you to your quote…</p>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/quoteme" element={<QuoteMe />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

